import React from 'react';
import StandardHeader from "../../components/global/StandardHeader";
import {Divider, Box} from "@mui/material";
import {LeftSidebar} from "../../layout-blueprints";
import UsersPreviewTable from "../../modules/userProfiles/components/UsersPreviewTable";
const UsersPage = () => {

  return (
    <LeftSidebar>
      <StandardHeader
        title="Users"
      />
      <Divider className="mb-3 mt-3" />
      <Box sx={{ width: '100%' }}>
        <UsersPreviewTable/>
      </Box>
    </LeftSidebar>
  );
};

export default UsersPage;